var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useMemo } from 'react';
import { useThemeStyle, getThemeKeyNames } from '../hooks/useThemeStyle';
import { DropdownIcon } from './icons/DropdownIcon';
export function CustomSelectField(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, id = _a.id, placeholder = _a.placeholder, disabled = _a.disabled;
    var css = useThemeStyle.apply(void 0, __spreadArray(__spreadArray([], getThemeKeyNames({ variant: variant }, 'textFields'), false), [{
            appearance: 'none',
            paddingRight: 30,
        }], false));
    var selectedValue = useMemo(function () {
        var index = options.findIndex(function (x) { return x.value === value; });
        return index === -1 ? '' : index;
    }, [options, value]);
    return (jsx("div", { className: className, sx: { position: 'relative' } },
        jsx("select", { css: css, id: id, value: selectedValue, onChange: function (e) {
                var _a;
                onChange((_a = options[parseInt(e.target.value)]) === null || _a === void 0 ? void 0 : _a.value);
            }, disabled: disabled },
            placeholder && (jsx("option", { value: "", disabled: true }, placeholder)),
            options.map(function (option, i) {
                return (jsx("option", { key: i, value: i }, option.text));
            })),
        jsx("div", { sx: {
                position: 'absolute',
                right: 0,
                top: '-0.25em',
                height: '100%',
                px: 2,
                display: 'flex',
                flexDirection: 'column',
                pointerEvents: 'none',
            } },
            jsx(DropdownIcon, { "aria-label": "expand", sx: {
                    my: 'auto',
                } }))));
}
//# sourceMappingURL=CustomSelectField.js.map